// extracted by mini-css-extract-plugin
export default {"appConfigContainer":"InvoiceMessageSettings_appConfigContainer__KUGVK","formContainer":"InvoiceMessageSettings_formContainer__0Jqia","locked":"InvoiceMessageSettings_locked__AwKgn"};